import React from 'react'
import { useTranslation } from 'react-i18next'
import { Container } from './styles'

const ResultsDesktop: React.FC = () => {
  const { t } = useTranslation(['components/results'])
  return (
    <Container>
      <span>{t('products-3d-desktop.results-1')}</span>
      <span>
        <b>{t('products-3d-desktop.results-2')}</b>
      </span>
      <span>
        <b>{t('products-3d-desktop.results-3')}</b>
      </span>
    </Container>
  )
}

const ResultsMobile: React.FC = () => {
  const { t } = useTranslation(['components/results'])
  return (
    <Container>
      <span>{t('products-ar.results-1')}</span>
      <span>
        <b>{t('products-ar.results-2')}</b>
      </span>
      <span>
        <b>{t('products-ar.results-3')}</b>
      </span>
    </Container>
  )
}
export { ResultsDesktop, ResultsMobile }
